import React, { useContext } from 'react';
import {
  StyleSheet,
  Text,
  View,
  Alert,
  ScrollView,
  TouchableOpacity,
  Image,
} from 'react-native';


const ButtonChangePage = ({ PaginaCarrinho, PaginaInicio, PaginaPerfil}) => {
  return (
    <View style={Style.ButtonsMenu}>
      <View>
      <TouchableOpacity style={Style.ButtonMenu} onPress={PaginaCarrinho}>
        <Image
          style={Style.IconMenu}
          source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/804330271288852490/IconeCarrinho.PNG'}}
        />
      </TouchableOpacity>
      </View>

      <View>
      <TouchableOpacity style={Style.ButtonMenu} onPress={PaginaInicio}>
        <Image
          style={Style.IconMenu}
          source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/804330274862137354/IconeCasa.PNG'}}
        />
      </TouchableOpacity>
      </View>
      
      <View>
      <TouchableOpacity style={Style.ButtonMenu} onPress={PaginaPerfil}>
        <Image
          style={Style.IconMenu}
          source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/804330284513492992/IconePerfil.PNG'}}
        />
      </TouchableOpacity>

      </View>
    </View>
  );
};

const TelaSobre = (props) => {

  function PaginaCarrinho() {
    props.navigation.navigate('CARRINHO');
  }

  function PaginaInicio() {
    props.navigation.navigate('PAGINA INICIAL');
  }

  function PaginaPerfil() {
    props.navigation.navigate('PERFIL');
  }
  
  return (

<View style={Style.layout}>

      <View style={Style.Cabeçalho}>

      <ButtonChangePage
          PaginaCarrinho={PaginaCarrinho}
          PaginaInicio={PaginaInicio}
          PaginaPerfil={PaginaPerfil}
          
        />
        <View style={{
          flexDirection: 'row-reverse',
          marginStart: 15,
        }}>
          <Image
            style={Style.CantinaSantaClara}
            source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/809404531241779240/logoCantina.png'}}
          />
        </View>
      </View>
        <Text style={Style.Text}>
        {"    "}O aplicativo Ficha Virtual foi desenvolvido para criar um novo meio para que os estudantes do Colégio Marista São Francisco "frequentem" a Cantina Santa Clara, promovendo a integração da tecnologia ao ambiente escolar. Para isso, desenvolvemos uma interface, visando facilitar a compra dos produtos oferecidos na cantina.
        {"\n"}{"    "}Esse projeto foi idealizado pelo GESF 2021, junto à equipe de robótica Delta T (Guilherme de Medeiros Burkert, Manoela Abreu Almeida e Rômulo Tavares Maciel).
        </Text>

        <View style={Style.LogosLayout}>
          

          <View style={Style.GESFDeltaLayout}>
            <Image
              style={Style.LogoGESF}
              source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/809404520403566602/logo_gesf.png'}}
            />
            
            <Image
              style={Style.LogoDeltaT}
              source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/809404533561884682/logo_delta_t.png'}}
            />
          </View>
          <View>
          <Image
            style={Style.LogoMarista}
            source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/809404527412248576/logo_marista_a.png'}}
          />
          </View>

        </View>
      </View>
  );
}
const Style = StyleSheet.create({
  //Pagina inicial --> Cardapio
  botões: {
    flexDirection: 'row',
    justifyContent: 'space-around',

    marginHorizontal: 20,
    width: 150,

    marginTop: 10,
  },

  logo: {
    height: 20,
    width: 20,
  },

  LogosLayout: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',

    marginTop: '10%',
  },

  GESFDeltaLayout: {
    flexDirection: 'row',
    justifyContent: 'center',
  },

  layout: {
    backgroundColor: 'rgba(179, 179, 179, 255)',
    
    width: '100%',
    height: '100%',
  },

  botão: {
    backgroundColor: 'rgba(255, 255, 255, 255)',
    borderRadius: 20,
    padding: 5,
    marginBottom: 20,
    marginTop: 10,
    marginHorizontal: 70,
    shadowColor: '#303838',
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 10,
    shadowOpacity: 0.35,
  },

  Text:{
    flexDirection:'row',
    justifyContent:'center',

    width: '95%',
    height: '47%',

    padding: 25,

    marginStart: '2.5%',
    marginTop: 25,

    backgroundColor: '#FFFFFF',

    borderRadius: 50,
    borderWidth: 1,
    borderColor: 'rgba(0, 58, 109, 255)',

    textAlign: 'justify',
    fontSize: 16,
    lineHeight: 25,
    fontFamily: 'System',
  },

  CantinaSantaClara: {
    
    width: 150,
    height: 85,
  },

  Cabeçalho: {
    flexDirection: 'column-reverse',
    width: '100%',
    height: 170,

    backgroundColor: 'rgba(0, 58, 109, 255)',
  },

  ButtonsMenu: {
    flexDirection: 'row',
    justifyContent: 'space-around',

    width: '100%',
    height: 80,

    marginTop: -10,
  },

  ButtonMenu: {
    
    flexDirection: 'row',
        

    backgroundColor: 'rgba(255, 255, 255, 255)',

    borderRadius: 50,

    padding: 7,

    marginBottom: 30,
    marginTop: 30,

    shadowColor: '#303838',
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 10,
    shadowOpacity: 0.35,
  },

  IconMenu: {
    height: 20,
    width: 20,
  },

  LogoMarista: {
    height: 75,
    width: 320,

    marginTop: 5,
  },

  LogoDeltaT: {
    height: 90,
    width: 90,

    marginStart: 50,
  },

  LogoGESF: {
    height: 90,
    width: 120,
  },
});

export default TelaSobre;
